import { advisoryDetailSchema } from '@repo/shared';
import type { AdvisoryDetail } from '@repo/shared';
import { apiRequest } from '../../lib/api';

/** `GET /api/v1/advisories/:id` — advisory detail by CVE or GHSA id. */
export function getAdvisory(id: string): Promise<AdvisoryDetail> {
  return apiRequest(`/v1/advisories/${encodeURIComponent(id)}`, advisoryDetailSchema);
}
